// Components/ui
import { SubsectionBodyContainer } from '../../../../layout';
import { Mail } from './components';
// Types
import { NewAddress } from '../../../../../../../../../utils/contactHelper';
import type { IContactAddress } from '@trii/types/dist/Contacts';

type Props = {
  emails: Array<NewAddress | IContactAddress>;
};

const Body = ({ emails }: Props) => {
  return (
    <SubsectionBodyContainer variant="large">
      {emails?.map((email) => (
        <Mail key={email.id} data={email} />
      ))}
    </SubsectionBodyContainer>
  );
};

export default Body;
